export default "__VITE_ASSET__DX3Yhlkr__"